import React from "react";
import "./BioPreviewSection.css";
import italianDish from "../../imgs/about.jpg"; // Replace with your image

function BioPreviewSection() {
  return (
    <div className="product-card">
      <div className="details-section">
      <p className="subheading">— CUSTOMER FAVORITE —</p>
      <h2 className="product-title">A Neighborhood Spot <br></br> You'll Love</h2>
      <p className="product-description">
      A Friendly and fast service without making you feel rushed. Delicious diner style food served in generous portions with reasonable prices. The go to breakfast is the Egg House Favorite: eggs, sausage, onions, and green peppers over hash browns covered in hollandaise… So Good!! A great place to enjoy a good cup of coffee and a relaxed breakfast or lunch.
      </p>
      </div>
      <div className="image-section">
        <img src={italianDish} alt="Italian Pasta" />
      </div>
    </div>
  );
}

export default BioPreviewSection;